import { $, $$ } from "@utils/dom";

import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import ResizeOrientation from "@utils/resize";
import Viewport from "@utils/viewport";

const SWIPER_OPTIONS = {
  modules: [Pagination, Navigation],
  freeMode: false,
  loop: false,
  slidesPerView: 2,
  spaceBetween: 16,
  breakpoints: {
    1200: {
      slidesPerView: 4,
      spaceBetween: 30
    }
  }
};

class PbRowStats {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this.slider = $('.pb-row-stats__slider', this.el);
    this.slides = [...$$('.swiper-slide', this.slider)];

    this._sliderOnDesktop = this.slides.length > 4 ? true : false;

    this._onResize = this._onResize.bind(this);
  }

  init() {
    this._onResize();

  }
  destroy() {
    this._unbindEvents();
    this._deleteSlider();

    this.el = null;
    this.emitter = null;
    this.slider = null;
    this.slides = null;

    this._sliderOnDesktop = null;

    this._onResize = null;


  }

  _createSlider(){
    this.swiper = new Swiper(this.slider, { ...SWIPER_OPTIONS, ...{
      navigation: {
        prevEl: $('.pb-row-stats__sliderPrev',this.el),
        nextEl: $('.pb-row-stats__sliderNext',this.el),
      },
      pagination: {
        el: $('.pb-row-stats__pagination',this.el),
        clickable: true
      }
    }});
  }

  _deleteSlider(){
    if(!this.swiper) return;

    this.swiper.destroy();
    this.swiper = null;

  }

  start() { this._bindEvents(); }
  stop() { this._unbindEvents(); }

  _bindEvents() {
    ResizeOrientation.add(this._onResize);
  }
  _unbindEvents() {
    ResizeOrientation.remove(this._onResize);
  }

  _onResize(){
    let allowSlider = false;

    if (Viewport.width > 768) {
      if (Viewport.width > 1200) {
        if (this._sliderOnDesktop) {
          allowSlider = true;
        }
      } else {
        allowSlider = true;
      }
    }

    if(allowSlider) {
      this._createSlider();
    } else {
      this._deleteSlider();
    }
  }
}

export default PbRowStats;
